export enum ContentType {
    FormData,
    Json
}